import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

import redirectUnlessIframe from "lib/redirectUnlessIframe";
import { unregister } from "./registerServiceWorker";

const container = document.getElementById("root");
const root = createRoot(container);

function render(Component) {
  root.render(Component);
}

if (!redirectUnlessIframe()) {
  unregister();
  render(<App />);
}
